module.exports = __webpack_public_path__ + "static/media/wizualizacja-2.eb812c50.png";